import { createStore } from "vuex";
import customizations from "./customizations";

export default createStore({
  modules: {
    customizations,
  },
});
